import TemplateContents from './TemplateContents';
import MemberSection from './MemberSection';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();

    this.memberSection = new MemberSection();
    // this.pack.common.addScrollTarget(this);
    this.pack.common.addEnterframeTarget(this);
  }

  reset() {
    super.reset();

    this.setVars();
    // this.pack.common.addScrollTarget(this);
    this.pack.common.addEnterframeTarget(this);
  }

  destruct() {
    super.destruct();

    // this.pack.common.removeScrollTarget(this);
    this.pack.common.removeEnterframeTarget(this);
  }

  setVars() {
    super.setVars();
  }

  setDom() {
    super.setDom();
  }

  initEvents() {
    super.initEvents();
  }

  start() {
    
  }

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
